import React from 'react';
export function StatsSection() {
  const stats = [{
    value: '90%+',
    label: 'Satisfacción del cliente'
  }, {
    value: '🇺🇸→🇻🇪',
    label: 'Miami → Venezuela ruta directa'
  }, {
    value: '✈️🚢',
    label: 'Envíos Aéreos y Marítimos'
  }, {
    value: '24/7',
    label: 'Atención personalizada'
  }];
  return <section className="py-12 bg-[#F5A623]" data-id="element-152">
      <div className="container mx-auto px-4 md:px-6" data-id="element-153">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x-0 md:divide-x divide-[#1B2B5E]/20" data-id="element-154">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center justify-center px-4" data-id="element-155">
              <div className="text-3xl md:text-4xl font-bold text-[#1B2B5E] mb-2 font-mono tracking-tight" data-id="element-156">
                {stat.value}
              </div>
              <div className="text-sm md:text-base font-medium text-[#1B2B5E]/80" data-id="element-157">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}